import moment from 'moment';
import { resolve } from 'acast-www-utils';
import { episodeHasCondition } from 'resources/episode';

export const DEFAULT_EARLY_RELEASE_DAY_COUNT = 7;

export const PermissionType = {
  PURCHASE: 'purchase',
};

export const PermissionCategory = {
  EARLY_RELEASE: 'early-release',
  EXCLUSIVE_CONTENT: 'exclusive-content',
};

export function getCategoryLabel(category) {
  switch (category) {
    case PermissionCategory.EARLY_RELEASE:
      return 'Early Release';

    case PermissionCategory.EXCLUSIVE_CONTENT:
      return 'Exclusive Content';

    default:
      return `Unknown Category ${category}`;
  }
}

export function getCategoryDescription(category) {
  switch (category) {
    case PermissionCategory.EARLY_RELEASE:
      return 'With an Early Release you can give your paying listeners the chance to access your content before everyone else. Below you can select the date this episode will be made available to everyone.';

    case PermissionCategory.EXCLUSIVE_CONTENT:
      return 'Your episode will be highlighted as Premium Content with Exclusive Access. This means that you grant only paying users access to this specific episode. Exclusive Content will stay Ad-free for a maximum listening experience.';

    default:
      return `Unknown Category ${category}`;
  }
}

export function getAvailableCategories(episode) {
  return Object.keys(PermissionCategory)
    .map(key => PermissionCategory[key])
    .filter(category => !episodeHasCondition(episode, category));
}

export function getFirstAvailableCategory(episode) {
  return getAvailableCategories(episode).shift();
}

export function createDefaultCondition(episode) {
  const category = getFirstAvailableCategory(episode);
  const startDate = resolve(episode, 'data.publishDate', null);
  const endDate =
    category === PermissionCategory.EARLY_RELEASE
      ? moment(startDate)
          .add(DEFAULT_EARLY_RELEASE_DAY_COUNT, 'days')
          .toISOString()
      : null;

  return {
    type: PermissionType.PURCHASE,
    category,
    startDate,
    endDate,
  };
}

export function getEarlyReleaseDayCount(condition) {
  const startDate = moment(condition.startDate);
  const endDate = moment(condition.endDate);

  if (startDate.isValid() && endDate.isValid()) {
    return endDate.diff(startDate, 'days');
  }

  return DEFAULT_EARLY_RELEASE_DAY_COUNT;
}

export function getEarlyReleaseDefaultEndDate(condition) {
  const dayCount = getEarlyReleaseDayCount(condition);

  return moment(condition.startDate)
    .add(dayCount, 'days')
    .toISOString();
}
